import React from "react";
import { FloatingButton } from "../../components/buttons/FloatingButton";
import { ShoppingCartButton } from "../../components/ShoppingCartButton";
import { Plan2PlateIconButton } from "../../components/buttons/Plan2PlateIconButton";

export function PlanToolbar({
  hasNewData,
  saveIsLoading,
  singleDayMode,
  onSave,
  onOpenSettings,
  onToggleCalendarMode,
  onToday,
  onRefresh,
}: {
  hasNewData: boolean;
  saveIsLoading: boolean;
  singleDayMode: boolean;
  onSave: () => void;
  onOpenSettings: () => void;
  onToggleCalendarMode: () => void;
  onToday: () => void;
  onRefresh: () => void;
}) {
  return (
    <>
      {(hasNewData || saveIsLoading) && (
        <FloatingButton
          leftIcon={"check"}
          position={"fixed"}
          isLoading={saveIsLoading}
          zIndex={"1"}
          onClick={onSave}
          caption={"Speichern"}
        />
      )}
      <div className="fixed left-0 right-0 pt-3 pb-[10px] z-[1] mx-auto flex w-full max-w-[800px] items-center justify-end gap-2 bg-[var(--p2p-bg)] px-4 py-0">
        <ShoppingCartButton />
        <Plan2PlateIconButton
          aria-label={"gear"}
          data-cy="settings-button"
          title={"Einstellungen"}
          icon={"gear"}
          onClick={onOpenSettings}
        />
        <Plan2PlateIconButton
          aria-label={"calendarMode"}
          data-cy="calendar-mode-button"
          title={singleDayMode ? "Wochenansicht" : "Tagesansicht"}
          icon={singleDayMode ? "calendar" : "day"}
          onClick={onToggleCalendarMode}
        />
        <Plan2PlateIconButton
          aria-label={"today"}
          data-cy="today-button"
          title={"Heute"}
          icon={"today"}
          onClick={onToday}
        />
        {!singleDayMode && (
          <Plan2PlateIconButton
            aria-label={"reload"}
            data-cy="reload-button"
            title={"Neu laden"}
            icon={"viewArrow"}
            onClick={onRefresh}
          />
        )}
      </div>
    </>
  );
}
